<script setup >
import { defineProps } from 'vue';
//import { BFormTextarea,BBadge, BTabs, BTab } from "bootstrap-vue-next";

// -----------------------------------------------
// v-modelに親コンポーネントで定義したデータ（ref/reactive）を指定する際に使用
// -----------------------------------------------

// -----------------------------------------------
// 親コンポーネントから子コンポーネントへデータを受け渡す
// -----------------------------------------------
const props = defineProps({
    // ラベル
    item_label: {
        type: String,
        required: false,
        default: "",
    },
    // 接頭辞
    item_prefix: {
        type: String,
        required: false,
        default: "",
    },
    // 接尾辞
    item_postfix: {
        type: String,
        required: false,
        default: "",
    },
    // リンク文字
    item_link_word: {
        type: String,
        required: false,
        default: "",
    },
    // URL
    item_link_url: {
        type: String,
        required: false,
        default: "",
    }
});

// -----------------------------------------------
// ローカル変数
// -----------------------------------------------
// ブラウザからデフォルトの言語を取得する
let locale = navigator.language;
if( locale != "ja" && locale != "en" ) locale = "en";

// -----------------------------------------------
// 既定計算
// -----------------------------------------------

// -----------------------------------------------
// 監視
// -----------------------------------------------
//
// -----------------------------------------------
// コンポーネントがマウントされる直前に呼び出されるフックを登録します。
// -----------------------------------------------
// onBeforeMount(() => {})
// -----------------------------------------------
// コンポーネントがマウントされた後に呼び出されるコールバックを登録します。
// -----------------------------------------------
// onMounted(() => {});
// -----------------------------------------------
// コンポーネントがリアクティブな状態変更により DOM ツリーを更新しようとする直前に呼び出されるフックを登録します。
// -----------------------------------------------
// onBeforeUpdate()
// -----------------------------------------------
// コンポーネントがリアクティブな状態変更によって DOM ツリーを更新した後に呼び出されるコールバックを登録します。
// -----------------------------------------------
//onUpdated(() => renderMarkdown());
// -----------------------------------------------
// コンポーネントインスタンスがアンマウントされる直前に呼び出されるフックを登録します。
// -----------------------------------------------
// onBeforeUnmount()
// -----------------------------------------------
// コンポーネントがアンマウントされた後に呼び出されるコールバックを登録します。
// -----------------------------------------------
// onUnmounted()
// -----------------------------------------------
// 子孫コンポーネントから伝搬するエラーをキャプチャーしたときに呼び出されるフックを登録します。
// -----------------------------------------------
// onErrorCaptured()

// -----------------------------------------------
// ローカル関数
// -----------------------------------------------

</script>

<template>
<div class="item-editor">
    <div class="preview_mode">
        {{ props.item_prefix }}&nbsp;<a :href="props.item_link_url" target="_blank">{{ props.item_link_word }}</a>&nbsp;{{ props.item_postfix }}
    </div>
</div>
</template>

<style scoped>
.item-editor {
  text-align: left;
  padding: 4px;
}
.preview_mode {
    box-sizing: border-box;
    margin: 7px 2px 7px 2px;
}
</style>
